import React from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import {
  emptyOption,
  getApplicantAutomationTriggerOptionsBySection,
} from './applicant-automation-display-utils';

export const TriggerDropdown = ({
  disabled,
  section,
  automation,
  addingAutomationForTrigger,
  communicationTypeValue,
  handleCommunicationTypeChange,
  triggerLabel,
}: {
  disabled: boolean;
  section: ApplicantAutomationSection;
  automation?: ApplicantAutomation | Partial<ApplicantAutomationCopy> | null;
  addingAutomationForTrigger?: ApplicantAutomationCommunicationType;
  communicationTypeValue: string;
  handleCommunicationTypeChange: ({ target }: React.ChangeEvent<{ value: unknown }>) => void;
  triggerLabel: string;
}) => {
  const automationTriggerOptions = emptyOption('Select Trigger').concat(
    getApplicantAutomationTriggerOptionsBySection(section),
  );

  // If we have a hard-coded trigger, don't return the Select
  if ((automation && automation.communicationType) || addingAutomationForTrigger) {
    if (!triggerLabel) {
      throw new Error(`Unrecognized trigger ${communicationTypeValue}`);
    }
    return null;
  }

  return (
    <Select
      className={`u-no-margin ${communicationTypeValue === '' ? 'u-color-gray' : ''}`}
      value={communicationTypeValue}
      onChange={handleCommunicationTypeChange}
      disabled={disabled}
      variant="standard"
      displayEmpty
      fullWidth
    >
      {automationTriggerOptions.map((option) => (
        <MenuItem key={option.value} value={option.value} disabled={option.value === ''}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export const OffsetDirectionDropdown = ({
  disabled,
  allowBeforeOrAfter,
  offsetDirection,
  handleAutomationRecurrenceChange,
}: {
  disabled: boolean;
  allowBeforeOrAfter: boolean;
  offsetDirection: string;
  handleAutomationRecurrenceChange: ({ target }: React.ChangeEvent<{ value: unknown }>) => void;
}) => {
  const offsetDirectionOptions = ['After', 'Before'].map((o) => ({
    value: o,
    label: o,
  }));

  return allowBeforeOrAfter ? (
    <Select
      className="u-no-margin"
      value={offsetDirection}
      onChange={handleAutomationRecurrenceChange}
      disabled={disabled}
      variant="standard"
    >
      {offsetDirectionOptions.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  ) : (
    <div className="typo-title">{offsetDirection.toLowerCase()}</div>
  );
};
